import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet, doAsyncPost, getDownload } from '@/api/async-util'

const types = {
    GET_DOWNLOADS: createAsyncMutation('GET_DOWNLOADS'),
    DOWNLOAD_FILE: createAsyncMutation('DOWNLOAD_FILE'),
    GET_LATEST_DOWNLOADS: createAsyncMutation('GET_LATEST_DOWNLOADS'),
    POST_DOWNLOAD_LOG: createAsyncMutation('POST_DOWNLOAD_LOG'),
}

const download = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getDownloads(store) {
            let url = api.download
            return doAsyncGet(store, { url, mutationTypes: types.GET_DOWNLOADS })
        },

        getLatestDownloads(store, oemId) {
            let url = api.download + 'Latest/?oemId=' + oemId
            return doAsyncGet(store, { url, mutationTypes: types.GET_LATEST_DOWNLOADS })
        },

        // POST
        postDownloadLog(store, payload) {
            let url = api.download + 'PostDownloadLog'
            doAsyncPost(store, { url, mutationTypes: types.POST_DOWNLOAD_LOG, payload })
        },

        // PUT
        downloadFile(store, payload) {
            let url = api.download + 'DownloadFile?id=' + payload.download.id
            return getDownload(store, { url, mutationTypes: types.DOWNLOAD_FILE, payload })
        },
        // DELETE
    },
    getters: {},
    types: types
}

export default download
